/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Delete_AccountInputs */

const en_profile_delete_account = /** @type {(inputs: Profile_Delete_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete my account`)
};

const es_profile_delete_account = /** @type {(inputs: Profile_Delete_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar mi cuenta`)
};

/**
* | output |
* | --- |
* | "Delete my account" |
*
* @param {Profile_Delete_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_delete_account = /** @type {((inputs?: Profile_Delete_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Delete_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_delete_account(inputs)
	return en_profile_delete_account(inputs)
});